import { PHONE, locationSchema } from "../structured-data-core";

export function getSouthLakeStructuredData() {
  const url = "https://restorehair.com/locations/texas/south-lake/";
  const description =
    "Find out about your hair transplant options in South Lake with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("South Lake", "950 E State Hwy 114", "Southlake", "TX", PHONE, url, description),
  ];
}
